import { MMKV } from 'react-native-mmkv';

const persistStorage = new MMKV();

export default {
  setItem: (key: string, value: boolean | string | number | ArrayBuffer) => {
    persistStorage.set(key, value);

    return Promise.resolve(true);
  },
  getItem: (key: string) => {
    const value = persistStorage.getString(key);

    return Promise.resolve(value);
  },
  removeItem: (key: string) => {
    persistStorage.delete(key);

    return Promise.resolve();
  },
};
